import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';

const EMPTY = { nombre: '', documento: '', tipo_documento: 'CC', telefono: '', direccion: '', zona: '', email: '' };

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [buscar, setBuscar] = useState('');
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function cargar() {
    api.get('/clientes', { params: { buscar, activo: 1 } })
      .then(r => setClientes(r.data))
      .catch(() => toast.error('Error cargando clientes'));
  }

  useEffect(() => {
    const t = setTimeout(cargar, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscar]);

  async function guardar(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await api.put(`/clientes/${editId}`, form);
        toast.success('Cliente actualizado');
      } else {
        await api.post('/clientes', form);
        toast.success('Cliente creado');
      }
      setModal(false);
      setForm(EMPTY);
      setEditId(null);
      cargar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  }

  function editar(c) {
    setForm({ nombre: c.nombre, documento: c.documento, tipo_documento: c.tipo_documento, telefono: c.telefono || '', direccion: c.direccion || '', zona: c.zona || '', email: c.email || '' });
    setEditId(c.id);
    setModal(true);
  }

  async function desactivar(id) {
    if (!window.confirm('¿Desactivar este cliente?')) return;
    try {
      await api.delete(`/clientes/${id}`);
      toast.success('Cliente desactivado');
      cargar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error');
    }
  }

  return (
    <div>
      <div style={styles.header}>
        <h2 style={styles.title}>Clientes</h2>
        <button style={styles.btnPrimary} onClick={() => { setForm(EMPTY); setEditId(null); setModal(true); }}>+ Nuevo Cliente</button>
      </div>
      <input
        placeholder="Buscar por nombre, documento o teléfono..."
        value={buscar}
        onChange={e => setBuscar(e.target.value)}
        style={styles.search}
      />
      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.thead}>
              <th>Nombre</th><th>Documento</th><th>Teléfono</th><th>Zona</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {clientes.map(c => (
              <tr key={c.id} style={styles.row}>
                <td>{c.nombre}</td>
                <td>{c.tipo_documento} {c.documento}</td>
                <td>{c.telefono || '-'}</td>
                <td>{c.zona || '-'}</td>
                <td>
                  <button style={styles.btnVer} onClick={() => navigate(`/clientes/${c.id}/estado-cuenta`)}>Estado de cuenta</button>
                  <button style={styles.btnEdit} onClick={() => editar(c)}>Editar</button>
                  <button style={styles.btnDel} onClick={() => desactivar(c.id)}>Desactivar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {clientes.length === 0 && <p style={styles.empty}>No hay clientes registrados</p>}
      </div>

      {modal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>{editId ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>
            <form onSubmit={guardar}>
              {[['nombre', 'Nombre completo', 'text', true], ['documento', 'Número de documento', 'text', true],
                ['telefono', 'Teléfono', 'tel', false], ['direccion', 'Dirección', 'text', false],
                ['zona', 'Zona', 'text', false], ['email', 'Email', 'email', false]].map(([key, label, type, req]) => (
                <div key={key} style={styles.field}>
                  <label style={styles.label}>{label}</label>
                  <input type={type} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} required={req} style={styles.input} />
                </div>
              ))}
              <div style={styles.field}>
                <label style={styles.label}>Tipo documento</label>
                <select value={form.tipo_documento} onChange={e => setForm({ ...form, tipo_documento: e.target.value })} style={styles.input}>
                  <option>CC</option><option>CE</option><option>NIT</option><option>PAS</option>
                </select>
              </div>
              <div style={styles.modalActions}>
                <button type="button" style={styles.btnCancel} onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" style={styles.btnPrimary} disabled={loading}>{loading ? 'Guardando...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  title: { margin: 0, color: 'var(--text-1)', fontSize: '1.5rem' },
  btnPrimary: { background: '#38bdf8', color: '#0f172a', border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', fontWeight: 700, cursor: 'pointer' },
  btnVer: { background: '#0f4c81', color: '#7dd3fc', border: 'none', borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', marginRight: '0.5rem', fontSize: '0.8rem' },
  btnEdit: { background: 'var(--bg-hover)', color: '#38bdf8', border: 'none', borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', marginRight: '0.5rem', fontSize: '0.8rem' },
  btnDel: { background: '#7f1d1d', color: '#fca5a5', border: 'none', borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', fontSize: '0.8rem' },
  btnCancel: { background: 'var(--bg-hover)', color: 'var(--text-1)', border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', cursor: 'pointer' },
  search: { width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-1)', fontSize: '0.95rem', marginBottom: '1rem', boxSizing: 'border-box' },
  tableWrap: { background: 'var(--bg-card)', borderRadius: '10px', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: 'var(--bg-app)', color: 'var(--text-2)', textAlign: 'left', fontSize: '0.8rem' },
  row: { borderBottom: '1px solid var(--border)', color: 'var(--text-1s)', fontSize: '0.9rem' },
  empty: { textAlign: 'center', color: 'var(--text-3)', padding: '2rem' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 },
  modal: { background: 'var(--bg-card)', borderRadius: '12px', padding: '2rem', width: '100%', maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { margin: '0 0 1.5rem', color: 'var(--text-1)' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.5rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', color: 'var(--text-2)', fontSize: '0.85rem', marginBottom: '0.3rem' },
  input: { width: '100%', padding: '0.65rem', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1)', fontSize: '0.95rem', boxSizing: 'border-box' }
};
